<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ep"> </p>
<p class="ep">On the field of battle it is a disgrace to the chief to be surpassed in valour by his companions, a disgrace to the companions not to come up to the valour of their chief. As for leaving a battle alive after your chief has fallen, that means lifelong infamy and shame. To defend and protect him, to put down one’s acts of heroism to his credit – that is really what they mean by allegiance. The chiefs fight for victory, the companions for their chief.</p>
<p class="epc">Tacitus, <span class="epub-i">Germania</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?4af3c416